import React, { FC, useEffect, useState } from 'react'
import { payPlanMobx, payChannelMobx } from '@mobx/mall/payment'
import { find } from '@dt/fe-utils/dist/lodash'
import { apConfigG } from '@ctrls/third'
import AlipaySimpleItem from './SimpleItem'

interface IProps {
  selected?: boolean;
}

const AlipayMethodItem: FC<IProps> = ({ selected }) => {
  const amount = payPlanMobx.externalMethod?.amount
  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    const method = find(
      payChannelMobx.availableExternalMethods,
      (x) => x === 'AlipayApp'
    )
    if (method) {
      const channel = payChannelMobx.methodChannel[method]
      if (channel.channelType === 'AlipayApp') {
        apConfigG.init(() => {
          setIsShow(true)
        })
      } else {
        setIsShow(true)
      }
    }
    return () => {
      apConfigG.remove()
    }
  }, [payChannelMobx.availableExternalMethods])

  // return (
  //   setIsShow && <AlipaySimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('AlipayApp')} />
  // )
  return (
    <AlipaySimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('AlipayApp')} />
  )
}

export default AlipayMethodItem
